var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.975 9.78148C14.9413 9.65887 14.8745 9.5478 14.7819 9.46082C14.6893 9.37367 14.5744 9.31377 14.4501 9.28775L9.73051 8.29331L13.2799 0.995354C13.3735 0.802544 13.3728 0.577422 13.2778 0.385291C13.1828 0.193352 13.0041 0.0560804 12.7942 0.0136419C12.5841 -0.0286225 12.3663 0.0284869 12.2043 0.168731L0.239498 10.5204C0.108686 10.6334 0.0250299 10.7912 0.00477194 10.9629C-0.015486 11.1346 0.0292226 11.3077 0.129995 11.4481C0.230766 11.5885 0.38044 11.6861 0.549671 11.7218L5.26922 12.7162L1.11417 21.2598C1.04344 21.4049 1.0258 21.5701 1.06405 21.7268C1.1023 21.8836 1.19417 22.0219 1.32375 22.1182C1.35833 22.1442 1.39536 22.1667 1.43431 22.1854C1.55953 22.2462 1.70012 22.2678 1.83791 22.2476C1.97571 22.2271 2.10407 22.1658 2.20642 22.0713L14.777 10.4746C14.8704 10.3885 14.9384 10.2783 14.9733 10.156C15.0082 10.0337 15.0089 9.90433 14.9752 9.7819L14.975 9.78148ZM3.96485 18.5647L6.90276 12.524L6.90259 12.5241C6.99567 12.3322 6.99532 12.1083 6.90171 11.9167C6.80793 11.7253 6.63119 11.5877 6.42265 11.5435L2.20125 10.6542L10.5588 3.42328L8.09716 8.48486C8.0039 8.67662 8.00425 8.90069 8.09803 9.09211C8.19182 9.2837 8.36839 9.42132 8.5771 9.46533L12.8517 10.366L3.96485 18.5647Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.c3b239500f2fd5d1f7d495d11ac9902a.svg";
export { ForwardRef as ReactComponent };